export default __webpack_public_path__ + "static/media/cubie.c6974af1.gif";